/**
 * Shared Living gallery lightbox, built on <dialog> (native Esc, focus containment and inert
 * background). Arrow keys move between photos; focus returns to the photo that opened it.
 * Also the testimonial slider controls (only present once there are two or more testimonials).
 */
import { stopScroll, startScroll } from './lenis.js';

export function initLightbox() {
  const dialog = document.querySelector('[data-lightbox]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const data = JSON.parse(dialog.querySelector('[data-lightbox-data]').textContent);
  const img = dialog.querySelector('[data-lightbox-img]');
  const cap = dialog.querySelector('[data-lightbox-cap]');
  const count = dialog.querySelector('[data-lightbox-count]');
  let index = 0;
  let opener = null;

  const show = (i) => {
    index = (i + data.length) % data.length;
    const item = data[index];
    img.src = item.src;
    img.alt = item.alt;
    img.width = item.width;
    img.height = item.height;
    img.onerror = () => { img.onerror = null; img.src = item.fallback; };
    cap.textContent = item.cap;
    count.textContent = `${index + 1} of ${data.length}`;
  };

  document.querySelectorAll('[data-lightbox-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      opener = btn;
      show(parseInt(btn.dataset.lightboxOpen, 10));
      dialog.showModal();
      stopScroll();
      dialog.querySelector('[data-lightbox-close]').focus();
    });
  });

  dialog.querySelector('[data-lightbox-prev]').addEventListener('click', () => show(index - 1));
  dialog.querySelector('[data-lightbox-next]').addEventListener('click', () => show(index + 1));
  dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
  });
  // Clicking the dark backdrop (outside the photo and controls) closes it.
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.classList.contains('lightbox__inner') || e.target.classList.contains('lightbox__figure')) dialog.close();
  });
  dialog.addEventListener('close', () => {
    startScroll();
    opener?.focus();
  });
}

export function initSlider() {
  const slider = document.querySelector('[data-slider]');
  if (!slider) return;
  const track = slider.querySelector('[data-slider-track]');
  const step = () => (track.firstElementChild?.offsetWidth || 300) + 24;
  slider.querySelector('[data-slider-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  slider.querySelector('[data-slider-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
  });
}
